import React from 'react';
import { useRestaurant } from '../../utils/contexts/restaurant-context';
import { useTranslation } from 'react-i18next';
import Drink from '../list/Drink';
import { getNamespaceForRestaurant } from '../../utils/mapEnv';
import './TimeDiscountModalContentStyle.css';

export default function TimeDiscountModalContent(props) {
    // const { onClickHandler } = props;

    const { t } = useTranslation();

    const { restaurant } = useRestaurant();

    // const { t } = useTranslation();

    let products = [];
    if (restaurant.beverages.length > 0 && restaurant.beverages[0].drinks.length > 0) {
        products.push(restaurant.beverages[0].drinks[0]);
    }

    return (
        <div className="time-discount-modal-content overflow-auto text-black ">
            {getNamespaceForRestaurant(restaurant.id) === "pago" ?
                <div className="p-3">
                    <p className="text-center">{t("timediscountmodalcontent.p_1")}</p>
                    <p className="text-center">{t("timediscountmodalcontent.p_2")}<span className="text-[#E10B25]">{t("timediscountmodalcontent.span_1")}</span></p>
                </div> :
                getNamespaceForRestaurant(restaurant.id) === "sanbitter" ?
                    <div>
                        <p className="text-center p-3">{t("timediscountmodalcontent.p_3")}<span className="text-[#E10B25]">{t("timediscountmodalcontent.span_2")}</span>{t("timediscountmodalcontent.p_4")}</p>
                    </div> :
                    getNamespaceForRestaurant(restaurant.id) === "redbull" ?
                        <div>
                            <p className="text-center p-3 text-white">{t("timediscountmodalcontent.p_5")}<span className="text-[#E10B25]">{t("timediscountmodalcontent.span_3")}</span>{t("timediscountmodalcontent.p_6")}
                            </p>
                        </div> : null}

            <div className="discount-products">
                {0 === products.length ?
                    (<p>{t("timediscountmodalcontent.p_7")}</p>) :
                    (products.map((drink, index) => <Drink drink={drink} key={index} isTastingMenu={false}></Drink>))}
            </div>
        </div>
    );
}
